import React from 'react';
import { AlertCircle } from 'lucide-react';

export const ClarificationModal = ({
  isOpen,
  message,
  ambituityScore,
  options,
  onSelect,
  onCancel,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
        animation: 'slideIn 0.3s ease-out'
      }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '1.5rem' }}>
          <AlertCircle style={{ 
            width: '24px', 
            height: '24px', 
            color: '#f59e0b', 
            flexShrink: 0,
            marginTop: '2px'
          }} />
          <div>
            <h2 style={{ margin: '0 0 0.5rem 0', fontSize: '1.25rem', fontWeight: '700', color: '#1e293b' }}>
              Clarification Needed
            </h2>
            <div style={{ fontSize: '0.875rem', color: '#64748b' }}>
              Ambiguity Score: <strong>{(ambituityScore * 100).toFixed(0)}%</strong>
            </div>
          </div>
        </div>

        {/* Message */}
        <p style={{ 
          margin: '0 0 1.5rem 0', 
          fontSize: '0.95rem', 
          color: '#475569',
          lineHeight: '1.5'
        }}>
          {message}
        </p>

        {/* Options */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1.5rem' }}>
          {options.map((option, idx) => (
            <button
              key={idx}
              onClick={() => !isLoading && onSelect(option)}
              disabled={isLoading}
              style={{
                padding: '0.875rem 1rem',
                backgroundColor: '#f1f5f9',
                border: '1px solid #cbd5e1',
                borderRadius: '8px',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                fontSize: '0.95rem',
                fontWeight: '500',
                color: '#1e293b',
                transition: 'all 0.2s ease',
                opacity: isLoading ? 0.6 : 1,
              }}
              onMouseEnter={(e) => {
                if (!isLoading) e.target.style.backgroundColor = '#e2e8f0';
              }}
              onMouseLeave={(e) => {
                if (!isLoading) e.target.style.backgroundColor = '#f1f5f9';
              }}
            >
              {option}
            </button>
          ))}
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            disabled={isLoading}
            style={{
              padding: '0.625rem 1.25rem',
              backgroundColor: '#f1f5f9',
              border: '1px solid #cbd5e1',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: '500',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.6 : 1
            }}
          >
            Cancel
          </button>
          {isLoading && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.625rem 1.25rem' }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #4F7CFF',
                borderTop: '2px solid transparent',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite'
              }} />
              <span style={{ fontSize: '0.9rem', color: '#475569' }}>Processing...</span>
            </div>
          )}
        </div>

        {/* CSS Animations */}
        <style>{`
          @keyframes slideIn {
            from {
              transform: translateY(-20px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
          
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default ClarificationModal;
